export const constants = {
  CLIENT_ERROR_CODE: "#0001",
  SERVER_ERROR_CODE: "#0000",
  MAX_ZIP_FILES_ERROR_CODE: "#ZIP0",
  AUTHENTICATION_TYPE_APPLICATION: "1",
  AUTHENTICATION_TYPE_EXTERNAL: "2",
  AUTHENTICATION_TYPE_AD: "3",
  CLASSIFICATION_TYPE_ENABLE_CLASS_MODEL: 2,
  TYPE_PREFIX: "type",
  CLASSIFICATION_TYPE_NUMBER_OF_PROTECTED: 18,
  LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL: 1,
  MESSAGE_LOG_TYPE_PROTECTED_INITIAL: 1,
  CLASSIFICATION_TYPE_ID: "classificationTypeId",
  CLASSIFICATION_PARENT_ID: "classificationParentId",
  MODEL_PARENT_ID: "modelParentId",
  PARTY_ROLE_TYPE_PARENT_ID: "parentPartyRoleTypeIdSpec",
  DEFAULT_MESSAGE_ID: 1,
  DATE_FORMAT: "YYYY-MM-DD",
  FETCH_EXCEPTION_MESSAGE: "Failed to fetch",
  NEW_ELEMENT_INDICATOR_PROPERTY: "__is_new",
  MOMENT_DATE_FORMAT: "LL",
  MOMENT_DATETIME_FORMAT: "LLL",
  LOCALE_HR: "hr",
  MIN_SEARCH_SIMILAR_LENGTH: 10,

  /*Operation constants*/
  OPERATION_CREATE: "create",
  OPERATION_PATCH: "patch",
  OPERATION_READ: "read",
  OPERATION_DELETE: "delete",
  OPERATION_CHANGE_LIFECYCLE: "change_lifecycle",
  OPERATION_SECURITY_ADMINISTRATION: "security_administration",
  OPERATION_ENTITY_ADMINISTRATION: "entity_administration",
  OPERATION_KNOWLEDGE_ADMINISTRATION: "knowledge_administration",
  OPERATION_REINDEX_ALL: "reindex_all",
  /*Operation constants - END*/

  RESOURCE_CLASSIFICATION: "classification",

  MENU_ITEM_TYPE_NEW_TAB: "new_tab",
  MENU_ITEM_TYPE_REACTIVATE: "reactivate",
  MENU_ITEM_TYPE_DELETE: "delete",
  MENU_ITEM_TYPE_MARK_AS_READ: "mark_as_read",
  MENU_ITEM_TYPE_MARK_AS_UNREAD: "mark_as_unread",
  MENU_ITEM_TYPE_OPEN: "open",

  KNOWLEDGE_ENTITY_TYPE: "hr.infodom.km.entity.KnowledgeEntity",
  C2S2_LINK: "https://servicedesk.infodom.hr/login.jsf",

  WEBSOCKET_TOPICS: {
    PARTY_MESSAGES_ID: {name: "partyMessages", includePartyId: true},
    PARTY_MESSAGES: {name: "partyMessages"}
  },

  LEFT_CLICK: 0,
  MIDDLE_CLICK: 1,
  RIGHT_CLICK: 2,

  SEARCHABLE_STATUS: {
    SEARCHABLE: "SEARCHABLE",
    NONSEARCHABLE: "NONSEARCHABLE",
    INDEXING: "INDEXING"
  },

  DOCUMENT_TYPE: {
    FILE: {id: "0", name: "FILE"},
    LINK: {id: "1", name: "LINK"}
  }
};
